// extracted by mini-css-extract-plugin
export default {"overlay":"GlobalPDFLoader_overlay__p89oq","loaderImage":"GlobalPDFLoader_loaderImage__ZrnLD"};